const category = 'Time tracker';

export const SegmentTimeTrackerEvent = {
    START: { category, event: 'Time tracker start clicked' },
    SAVE: { category, event: 'Time tracker save clicked' },
    CARD_CLICK: { category, event: 'Time tracker card clicked' },
    STOP: { category, event: 'Time tracker stop clicked' }
}
